import * as React from 'react';
import { useGetAddressQuery } from "../../../apis/Address.api";
import { PrimaryAddress, Address } from "../../../types/models/Address";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: Address;
};

export const AddressNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<>{ data?.email }
                    {data?.address && <> | </> }{ data?.address }
                    {data?.city && <> | </> }{ data?.city }
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const AddressName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetAddressQuery(PrimaryAddress.fromId(id))
    return (<AddressNameDisplay data={data}/>)
}

export default AddressName;
